var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNeutralWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    fill: "none",
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.8,
    cy: 15.065,
    r: 15,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#21214D",
    d: "m11.618 24.766.015.008c.454.198 1.102-.006 1.558-.382a7.66 7.66 0 0 1 2.038-1.211 8.863 8.863 0 0 1 1.978-.618 8.78 8.78 0 0 1 2.073-.151c.79.007 1.58.129 2.332.376.562.184 1.24.135 1.589-.216l.014-.014c.347-.343.12-.952-.594-1.261-1.57-.678-3.378-.91-5.184-.723-.196.028-.393.059-.591.097-.2.038-.394.081-.587.127-1.748.49-3.345 1.37-4.552 2.577-.553.55-.54 1.2-.089 1.391ZM12.802 12.256c0 1.515-1.07 2.744-2.39 2.744s-2.39-1.229-2.39-2.744c0-1.516 1.07-2.745 2.39-2.745s2.39 1.229 2.39 2.745ZM23.578 12.256c0 1.515-1.07 2.744-2.39 2.744s-2.39-1.229-2.39-2.744c0-1.516 1.07-2.745 2.39-2.745s2.39 1.229 2.39 2.745Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.82 11.441a.868.868 0 1 1-1.736 0 .868.868 0 0 1 1.735 0ZM21.596 11.441a.868.868 0 1 1-1.736 0 .868.868 0 0 1 1.736 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNeutralWhite);
export default __webpack_public_path__ + "static/media/icon-neutral-white.43286bf894bd3e5062e646687631a4c8.svg";
export { ForwardRef as ReactComponent };